<mat-list class="px-2 py-0 w-full h-full flex flex-col justify-between bg-white rounded-xl overflow-auto">
    <div class="p-2" [class.pb-0]="bottomItemsList()?.length > 0">
        @for (item of topItemsList(); track item.title) {
            <ng-container *ngTemplateOutlet="listItemTemplate; context: { $implicit: item }"></ng-container>
            @if (!$last) {
                <mat-divider></mat-divider>
            }
        }
    </div>
    @if (bottomItemsList()?.length > 0) {
        <div class="p-2 pt-0">
            @for (item of bottomItemsList(); track item.title) {
                <mat-divider class="mt-auto"></mat-divider>
                <ng-container *ngTemplateOutlet="listItemTemplate; context: { $implicit: item }"></ng-container>
            }
        </div>
    }
</mat-list>

<ng-template #listItemTemplate let-item>
    <mat-list-item
        matRipple
        class="cursor-pointer hover:bg-primary/5 h-auto min-h-12"
        (click)="item.onClick ? item.onClick() : itemClicked.emit(item.linkedPage)">
        @if (item.icon) {
            <mat-icon
                matListItemIcon
                [svgIcon]="item.icon"
                class="my-auto scale-125 text-default"
                [class.text-warn]="item.dangerousOp"
            ></mat-icon>
        }

        <span
            matListItemTitle
            class="text-xl text-default"
            [class.text-warn]="item.dangerousOp"
        >{{ item.title }}</span>

        @if (item.subtitle) {
            <span
                class="text-default text-wrap leading-none"
                [class.text-warn]="item.dangerousOp"
                [innerHTML]="item.subtitle"
            ></span>
        }
        @if (!item.hideChevron) {
            <mat-icon
                matListItemMeta
                svgIcon="heroicons_outline:chevron-right"
                class="my-auto"
                [class.text-warn]="item.dangerousOp"
            ></mat-icon>
        }
    </mat-list-item>
</ng-template>
